import {Alert, Button, Col, Form, Row, Table} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import ApiService from "../../services/ApiService";

const emptyForm = {title: "", place: "", rules: "", image: null};

const AdminPools = () => {

    const [pools, setPools] = useState([]);
    const [form, setForm] = useState(emptyForm);
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState(null); // { type: 'success' | 'danger', text }

    const loadPools = () => {
        setLoading(true);
        ApiService.getAllPools(100000)
            .then((obj) => setPools(obj.piscinaDtos || []))
            .catch(() => setMessage({type: "danger", text: "Errore nel caricamento delle piscine."}))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadPools();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setField = (k, v) => setForm((prev) => ({...prev, [k]: v}));

    const resetForm = () => {
        setForm(emptyForm);
        setEditingId(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const title = form.title.trim();
        if (!title) return;
        const payload = {title, place: form.place.trim(), rules: form.rules.trim()};
        const action = editingId
            ? ApiService.editPool({...payload, image: form.image}, editingId)
            : ApiService.createPool(payload);
        action
            .then(() => {
                setMessage({
                    type: "success",
                    text: editingId ? "Piscina aggiornata." : `Piscina "${title}" aggiunta.`
                });
                resetForm();
                loadPools();
            })
            .catch(() => setMessage({type: "danger", text: "Operazione non riuscita. Riprova."}));
    };

    const startEdit = (pool) => {
        setEditingId(pool.id);
        setForm({
            title: pool.title || "",
            place: pool.place || "",
            rules: pool.rules || "",
            image: pool.image
        });
        setMessage(null);
        window.scrollTo({top: 0, behavior: "smooth"});
    };

    const handleDelete = (pool) => {
        if (!window.confirm(`Eliminare la piscina "${pool.title}"?`)) return;
        ApiService.deletePool(pool.id)
            .then(() => {
                setMessage({type: "success", text: `Piscina "${pool.title}" eliminata.`});
                if (editingId === pool.id) resetForm();
                loadPools();
            })
            .catch(() => setMessage({
                type: "danger",
                text: `Impossibile eliminare "${pool.title}". Potrebbe essere ancora usata da uno o più corsi: riassegna prima quei corsi a un'altra piscina, poi riprova.`
            }));
    };

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col><Back/></Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={'title-page-section mt-5 mb-4'}>
                                <h2 className={'title'}>Piscine</h2>
                            </div>
                        </Col>
                    </Row>

                    {message &&
                        <Row className={'mb-3'}>
                            <Col xs={12} lg={8}>
                                <Alert variant={message.type} dismissible onClose={() => setMessage(null)}>
                                    {message.text}
                                </Alert>
                            </Col>
                        </Row>
                    }

                    <Row className={'mb-4'}>
                        <Col xs={12} lg={8}>
                            <Form onSubmit={handleSubmit} className={'p-3 border rounded'}>
                                <h5 className={'mb-3'}>{editingId ? "Modifica piscina" : "Aggiungi una nuova piscina"}</h5>
                                <Form.Group className={'mb-3'}>
                                    <Form.Label className={'fw-bold'}>Nome *</Form.Label>
                                    <Form.Control type={'text'} value={form.title}
                                                  placeholder={'Es. Lido di Locarno'}
                                                  onChange={(e) => setField("title", e.target.value)}/>
                                </Form.Group>
                                <Form.Group className={'mb-3'}>
                                    <Form.Label className={'fw-bold'}>Luogo</Form.Label>
                                    <Form.Control type={'text'} value={form.place}
                                                  placeholder={'Es. Via Rezzonico, Locarno'}
                                                  onChange={(e) => setField("place", e.target.value)}/>
                                </Form.Group>
                                <Form.Group className={'mb-3'}>
                                    <Form.Label className={'fw-bold'}>Regole / note</Form.Label>
                                    <Form.Control as={'textarea'} rows={3} value={form.rules}
                                                  onChange={(e) => setField("rules", e.target.value)}/>
                                </Form.Group>
                                <div className={'d-flex gap-2'}>
                                    <Button type={'submit'} className={'btn btn-primary fw-bold px-4'}
                                            disabled={!form.title.trim()}>
                                        {editingId ? "Salva modifiche" : "Aggiungi piscina"}
                                    </Button>
                                    {editingId &&
                                        <Button variant={'outline-secondary'} onClick={resetForm}>Annulla</Button>
                                    }
                                </div>
                                <Form.Text className={'text-muted d-block mt-2'}>
                                    L'immagine della piscina si gestisce separatamente (non da qui).
                                </Form.Text>
                            </Form>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={8}>
                            {loading ?
                                <p>Caricamento…</p>
                                :
                                <Table hover responsive className={'align-middle'}>
                                    <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Luogo</th>
                                        <th className={'text-end'}>Azioni</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {pools.length === 0 &&
                                        <tr>
                                            <td colSpan={3} className={'text-muted'}>Nessuna piscina. Aggiungine una
                                                qui sopra.
                                            </td>
                                        </tr>
                                    }
                                    {pools.map((pool) => (
                                        <tr key={pool.id}>
                                            <td>{pool.title}</td>
                                            <td className={'text-muted'}>{pool.place}</td>
                                            <td className={'text-end'}>
                                                <div className={'d-flex gap-2 justify-content-end'}>
                                                    <Button size={'sm'} variant={'outline-primary'}
                                                            onClick={() => startEdit(pool)}>Modifica</Button>
                                                    <Button size={'sm'} variant={'outline-danger'}
                                                            onClick={() => handleDelete(pool)}>Elimina</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
}

export default AdminPools;
